var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card',{class:_vm.maxH ? 'max-h-screen' : '',attrs:{"nospace":true}},[_c('ul',{class:['divide-y divide-gray-200', `${_vm.maxH ? 'max-h-screen flex flex-col overflow-hidden' : ''}`]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }